import { collectionEngine, collectionEngineV1 } from '../apis.js';
const interactionAPIV1 = collectionEngineV1('/interactions');
const emailServersAPIV1 = collectionEngineV1('/email-servers');
const interactionAPI = collectionEngine('/interactions');
export const getByReferenceId = (referenceType, referenceId, casualConsistency) => interactionAPIV1('GET', `/${referenceType}/${referenceId}${casualConsistency ? '?casualConsistency=true' : ''}`);
export const getMultiple = (query, config) => interactionAPIV1('POST', `/multiple${config?.paused ? '?paused=true' : ''}`, {
    body: query,
});
export const create = (interaction) => interactionAPIV1('POST', `/`, { body: interaction });
export const patch = (id, patch) => interactionAPIV1('PATCH', `/${id}`, { body: patch });
export const getInsightsTotals = () => interactionAPIV1('GET', `/insights/totals`);
export const del = (id) => interactionAPIV1('DELETE', `/${id}`);
export const clone = (id, toCaseId) => interactionAPIV1('POST', `/${id}/clone`, {
    body: { toCaseId },
});
export const getEmailServer = (id) => emailServersAPIV1('GET', `/${id}`);
export const returnLetter = (id, reason) => interactionAPI('PUT', `/letter-interaction/${id}/${reason}`);
//# sourceMappingURL=interactions.js.map